<template>
  <div class="home mt-3">
    <div class="d-flex flex-wrap justify-content-between align-items-center mb-3">
      <div class="d-flex align-items-center flex-wrap">
        <h2 class="mb-0 mr-3">
          Atributos
          <small style="font-size: 13px" v-if="idKeywordSel">servicio {{ idKeywordSel }} / </small>
          <small style="font-size: 13px" v-if="idProductoSel">producto {{ idProductoSel }} / </small>
          <small style="font-size: 13px" v-if="idOperadorSel">operador {{ idOperadorSel }} / </small>
          <small style="font-size: 13px" v-if="idTipoSuscripcionSel">tipo de Suscripción {{ idTipoSuscripcionSel }}</small>
        </h2>
      </div>
    </div>
    <div class="alert alert-success" role="alert" v-if="success">
      {{ success }}
    </div>
    <div class="alert alert-danger" role="alert" v-if="error">{{ error }}</div>

    <!-- Explicación de los niveles de atributos -->
    <div class="card mb-3 border-info shadow-sm">
      <div
        class="card-header py-2 px-3 bg-light d-flex justify-content-between align-items-center"
        style="cursor: pointer;"
        @click="showExplicacionNiveles = !showExplicacionNiveles"
      >
        <span class="font-weight-bold text-dark" style="font-size: 13.5px;">
          <i class="bi bi-info-circle-fill text-info mr-2"></i>Significado de los Niveles de Atributos (Jerarquía)
        </span>
        <button type="button" class="btn btn-sm btn-link text-info p-0 font-weight-bold">
          <i :class="showExplicacionNiveles ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
          <small class="ml-1">{{ showExplicacionNiveles ? 'Ocultar' : 'Ver explicación' }}</small>
        </button>
      </div>
      <div v-show="showExplicacionNiveles" class="card-body py-2 px-3 bg-white" style="font-size: 13px;">
        <p class="text-muted mb-2">
          Los valores se determinan por jerarquía en cascada: el nivel más específico sobreescribe a los más generales.
        </p>
        <div class="row">
          <div class="col-md-6 col-lg mb-2">
            <span class="badge badge-primary px-2 py-1 mb-1">1. servicio</span>
            <p class="mb-0 text-dark small">
              <b>Nivel Servicio:</b> Prioridad máxima. Valor configurado puntualmente para este servicio. Sobrescribe Producto, Operador y Default.
            </p>
          </div>
          <div class="col-md-6 col-lg mb-2">
            <span class="badge badge-info px-2 py-1 mb-1">2. producto</span>
            <p class="mb-0 text-dark small">
              <b>Nivel Producto:</b> Aplica a todos los servicios de este producto. Sobrescribe Operador y Default, salvo que el servicio tenga su propio valor.
            </p>
          </div>
          <div class="col-md-6 col-lg mb-2">
            <span class="badge badge-warning px-2 py-1 mb-1 text-dark">3. operador</span>
            <p class="mb-0 text-dark small">
              <b>Nivel Operador:</b> Configurado a nivel telco/operador. Aplica si no está definido en Producto o Servicio. Sobrescribe Default.
            </p>
          </div>
          <div class="col-md-6 col-lg mb-2">
            <span class="badge badge-secondary px-2 py-1 mb-1">4. tipo_suscripcion</span>
            <p class="mb-0 text-dark small">
              <b>Nivel Modalidad:</b> Configurado según la periodicidad o tipo de suscripción. Aplica en caso de no existir niveles superiores.
            </p>
          </div>
          <div class="col-md-6 col-lg mb-2">
            <span class="badge badge-dark px-2 py-1 mb-1">5. default</span>
            <p class="mb-0 text-dark small">
              <b>Nivel Default:</b> Valor base general del catálogo. Se toma cuando ningún nivel superior tiene un valor específico asignado.
            </p>
          </div>
        </div>
      </div>
    </div>

    <div
      class="row mb-3"
      v-if="atributosBusqueda && atributosBusqueda.data && atributosBusqueda.data.length"
    >
      <div class="col-md-5 col-lg-4">
        <div class="input-group input-group-sm">
          <div class="input-group-prepend">
            <span class="input-group-text"><i class="bi bi-search"></i></span>
          </div>
          <input
            type="text"
            class="form-control"
            placeholder="Buscar por nombre del atributo..."
            v-model="filtroAtributoNombre"
          />
          <div class="input-group-append" v-if="filtroAtributoNombre">
            <button
              class="btn btn-outline-secondary"
              type="button"
              @click="filtroAtributoNombre = ''"
              title="Limpiar búsqueda"
            >
              <i class="bi bi-x"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <table
      class="table xtable-responsive table-striped table-fixed table-sm"
      v-if="atributosBusqueda && atributosBusqueda.data.length"
    >
      <thead>
        <tr>
          <!--            <th scope="col" width="40" >Id</th> -->
          <th scope="col" width="250">Atributo</th>
          <!--   <th scope="col" width="80">Id Servicio</th>
                  <th scope="col" width="80">Id Producto</th>
                  <th scope="col" width="80">Id Operador</th>
                  <th scope="col" width="90" class="nobr">Id Tipo Suscripción</th> -->
          <th scope="col" width="130">Nivel</th>
          <th scope="col">Valor</th>
          <th scope="col" width="110">Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="atributosFiltrados.length === 0">
          <td colspan="4" class="text-center text-muted py-3">
            <i class="bi bi-info-circle mr-1"></i> No se encontraron atributos que coincidan con "{{ filtroAtributoNombre }}".
          </td>
        </tr>
        <tr
          v-for="atributoItem of atributosFiltrados"
          v-bind:key="atributoItem.id_atributo"
          :class="{ 'table-danger fila-vacia': isValorVacio(atributoItem.valor) }"
        >
          <!--         <th scope="row" >{{ atributoItem.id_atributo }}</th> -->
          <td :title="atributoItem.atributo">
            <span :class="{ 'font-weight-bold text-danger': isValorVacio(atributoItem.valor) }">
              {{ atributoItem.atributo }}
            </span>
          </td>
          <!--   <td >{{ atributoItem.id_keyword_has_producto }}</td>
                  <td >{{ atributoItem.id_producto }}</td>
                  <td >{{ atributoItem.id_operador }}</td>
                  <td >{{ atributoItem.id_tipo_suscripcion }}</td> -->
          <td>
            <span
              class="badge"
              :class="{
                'badge-primary': atributoItem.nivel == 'servicio',
                'badge-info': atributoItem.nivel == 'producto',
                'badge-warning text-dark': atributoItem.nivel == 'operador',
                'badge-secondary': atributoItem.nivel == 'tipo_suscripcion',
                'badge-dark': atributoItem.nivel == 'default',
              }"
              :title="getExplicacionNivel(atributoItem.nivel)"
            >
              {{ atributoItem.nivel }}
            </span>
          </td>
          <td :title="atributoItem.valor">
            <a
              style="cursor: pointer; color: #17a2b8; font-weight: bold;"
              v-if="atributoItem.atributo == 'billing_sequence_id' && !isValorVacio(atributoItem.valor)"
              @click="getBillingSequencesBusqueda(atributoItem.valor)"
            >
              {{ atributoItem.valor }}
            </a>
            <span v-else-if="isValorVacio(atributoItem.valor)" class="text-danger font-italic font-weight-bold">
              <i class="bi bi-exclamation-triangle mr-1"></i>(En blanco)
            </span>
            <span v-else>{{ atributoItem.valor }}</span>
          </td>
          <td>
            <button
              v-if="atributoItem.nivel != 'default'"
              class="btn btn-info btn-sm mr-1 pt-0 pb-1"
              data-toggle="tooltip"
              data-placement="top"
              title="Jerarquía del atributo"
              :class="atributoItem.nivel == 'default' ? 'disabled' : ''"
              @click="
                !(atributoItem.nivel == 'default') &&
                  showJerarquia(atributoItem)
              "
            >
              <small class="bi-bar-chart-steps"></small>
            </button>
            <button
              v-if="atributoItem.nivel != 'default'"
              class="btn btn-primary btn-sm mr-1 pt-0 pb-1"
              data-toggle="tooltip"
              data-placement="top"
              title="Editar atributo"
              @click="showEdit(atributoItem)"
            >
              <small class="bi-pencil-fill"></small>
            </button>
            <button
              v-if="atributoItem.nivel == nivelpiso && nivelpiso != 'default'"
              class="btn btn-danger btn-sm pt-0 pb-1"
              data-toggle="tooltip"
              data-placement="top"
              title="Eliminar atributo"
              @click="
                !(atributoItem.nivel == 'default') && showDelete(atributoItem,atributoItem.nivel)
              "
            >
              <small class="bi-trash-fill"></small>
            </button>

              <button
              v-if="atributoItem.nivel == 'default'"
              class="btn btn-info btn-sm pt-0 pb-1"
              data-toggle="tooltip"
              data-placement="top"
              title="Crear atributo"
              @click="showCreate(atributoItem)"

            >
              <small v-if="atributoItem.nivel == 'default' && atributoItem.valor && (!idKeywordSel && !idProductoSel && !idOperadorSel && !idTipoSuscripcionSel )" class="bi-pencil-fill"></small>
              <small v-if="atributoItem.nivel == 'default' && !atributoItem.valor && (!idKeywordSel && !idProductoSel&& !idOperadorSel && !idTipoSuscripcionSel )" class="bi-plus"></small>
              <small v-if="(idKeywordSel || idProductoSel || idOperadorSel || idTipoSuscripcionSel)" class="bi-plus"></small>
            </button>
          </td>
        </tr>
      </tbody>

    </table>




    <div
      v-if="
        !(
          atributosBusqueda &&
          atributosBusqueda.data &&
          atributosBusqueda.data.length
        ) && post
      "
    >
      <div class="alert alert-info">
        No se obtubieron atributos con el criterio seleccionado.
      </div>
    </div>
    <div v-if="error">{{ error.message }}</div>
    <!-- Modal -->



  <div v-if="showModal2">
            <transition name="modal">
                <div class="modal-mask nested-modal-mask">
                    <div class="modal-wrapper">
                        <div class="modal-dialog modal-dialog-scrollable"
                            role="document"
                            :class="operation == 'jerarquia' ? 'modal-lg modal-dialog-scrollable' : ''"
                        >
                            <div class="modal-content">
                                <div class="modal-header">

                  <h5   class="modal-title">BillingSequence {{billingSequencesBusqueda.data[0].id_billing_sequence}}
             
                  </h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal2">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                        <div class="form-group">
                                            <label>Secuencia</label>
                                            <input class="form-control" name="sequence" type="text" v-model="billingSequencesBusqueda.data[0].sequence" />
                                        </div>
                                        <div class="form-group">
                                            <label>Descripción</label>
                                            <input class="form-control" name="descripcion"  type="text" v-model="billingSequencesBusqueda.data[0].descripcion" />
                                        </div>
                                        <div class="form-group">
                                            <label>Tipo</label>
                                            <select class="form-control" name="tipo" v-model="billingSequencesBusqueda.data[0].tipo" aria-label="Tipo">
                                                <option :value='null'>Seleccione un tipo...</option>
                                                    <option value="STANDARD" >
                                                        STANDARD
                                                    </option>
                                                <option value="PREMIUM" >
                                                        PREMIUM
                                                    </option>
                                            </select>
                                        </div>

                                          <div class="form-group">
                                            <label>Precio</label>
                                            <input class="form-control" name="fullPriceTax"  type="text" v-model="billingSequencesBusqueda.data[0].fullPriceTax" />
                                        </div>

                                          <div class="form-group">
                                            <label>Precio sin Impuestos</label>
                                            <input class="form-control" name="fullPrice"  type="text" v-model="billingSequencesBusqueda.data[0].fullPrice" />
                                        </div>

                                          <div class="form-group">
                                            <label>MinPriceBS</label>
                                            <input class="form-control" name="minPriceBS"  type="text" v-model="billingSequencesBusqueda.data[0].minPriceBS" />
                                        </div>
                                         <div class="form-group">
                                            <label>Restricciones</label>
                                            <input class="form-control" name="billRestriction"  type="text" v-model="billingSequencesBusqueda.data[0].billRestriction" />
                                        </div>
                                         <div class="form-group">
                                               <label>Frecuencia</label>
                                            <input class="form-control" name="frecuency"  type="text" v-model="billingSequencesBusqueda.data[0].frecuency" />
                                        </div>
                                        <div class="form-group">    
                                          <label>Lifetime</label>
                                            <input class="form-control" name="lifetime"  type="text" v-model="billingSequencesBusqueda.data[0].lifetime" />
                                        </div>
                                    
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-secondary" @click="closeModal2">
                                        <span >Cerrar</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>















    <div v-if="showModal">
      <transition name="modal">
        <div class="modal-mask nested-modal-mask">
          <div class="modal-wrapper">
            <div
              class="modal-dialog"
              role="document"
              :class="
                operation == 'jerarquia'
                  ? 'modal-lg modal-dialog-scrollable'
                  : ''
              "
            >
              <div class="modal-content">
                <div class="modal-header">
                  <h5 v-if="operation == 'delete'" class="modal-title">
                    Borrar atributo a Nivel 
                      <span v-if="idKeywordSel">Servicio( ID: {{idKeywordSel}} )</span>
                    <span  v-else-if="idProductoSel">Producto( ID: {{idProductoSel}} )</span>
                    <span  v-else-if="idOperadorSel">Operador( ID: {{idOperadorSel}} )</span>
                    <span  v-else-if="idTipoSuscripcionSel">Tipo De Suscripción( ID: {{idTipoSuscripcionSel}} )</span>
                    <span  v-else-if="!idKeywordSel">Default</span>
                  </h5>
                  <h5 v-if="operation == 'edit'" class="modal-title">
                    Editar atributo a Nivel 
                    <span v-if="idKeywordSel">Servicio( ID: {{idKeywordSel}} )</span>
                    <span  v-else-if="idProductoSel">Producto( ID: {{idProductoSel}} )</span>
                    <span  v-else-if="idOperadorSel">Operador( ID: {{idOperadorSel}} )</span>
                    <span  v-else-if="idTipoSuscripcionSel">Tipo De Suscripción( ID: {{idTipoSuscripcionSel}} )</span>
                    <span  v-else-if="!idKeywordSel">Default</span>
                  </h5>
                  <h5 v-if="operation == 'create'" class="modal-title">
                    Creando atributo a Nivel 
                    <span v-if="idKeywordSel">Servicio( ID: {{idKeywordSel}} )</span>
                    <span  v-else-if="idProductoSel">Producto( ID: {{idProductoSel}} )</span>
                    <span  v-else-if="idOperadorSel">Operador( ID: {{idOperadorSel}} )</span>
                    <span  v-else-if="idTipoSuscripcionSel">Tipo De Suscripción( ID: {{idTipoSuscripcionSel}} )</span>
                    <span  v-else-if="!idKeywordSel">Default</span>
                  </h5>

                  <h5 v-if="operation == 'jerarquia'" class="modal-title">
                    Jerarquía del atributo
                  </h5>

                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    @click="closeModal"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div v-if="operation == 'jerarquia'">
                    <div class="mb-1">
                      Id Atributo: <b>{{ editData.id_atributo }}</b>
                    </div>
                    <div class="mb-3">
                      Atributo: <b>{{ editData.atributo }}</b>
                    </div>
                    <table
                      class="table table-sm table-striped"
                      style="table-layout: fixed"
                    >
                      <thead>
                        <tr>
                          <!-- <th scope="col" xwidth="80">Id Servicio</th>
                                                  <th scope="col" xwidth="80">Id Producto</th>
                                                  <th scope="col" xwidth="80">Id Operador</th>
                                                  <th scope="col" xwidth="90" class="nobr">
                                                      Id Tipo Suscripción
                                                  </th> -->
                          <th scope="col" xwidth="130">Nivel</th>
                          <th scope="col">Valor</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item of jerarquia" v-bind:key="item.nivel">
                          <!-- <td >
                                                      {{ item.id_keyword_has_producto }}
                                                  </td>
                                                  <td >{{ item.id_producto }}</td>
                                                  <td >{{ item.id_operador }}</td>
                                                  <td >
                                                      {{ item.id_tipo_suscripcion }}
                                                  </td> -->
                          <td>{{ item.nivel }}</td>
                          <td :title="item.valor" style="word-wrap: break-word">
                            {{ item.valor }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <form v-if="operation == 'delete' || operation == 'edit' || operation == 'create'">
                    <div class="form-group">
                      <label>Atributo</label> <b>{{ editData.atributo }}</b>
                    </div>

                    <div class="form-group" v-if="operation != 'create'">
                      <label>Nivel con valor</label> <b>{{ editData.nivel }}</b>
                    </div>
                    <div v-if="operation == 'delete'" class="form-group">
                      <label>Valor</label> <b>{{ editData.valor }}</b>
                    </div>
                    <div v-if="operation == 'edit' || operation == 'create'" class="form-group">
                      <label for="exampleFormControlTextarea1">Valor {{ operation == 'create' ? 'nuevo' : 'heredado / actual' }}</label>
                      <textarea
                        v-model="valor"
                        class="form-control"
                        id="exampleFormControlTextarea1"
                        rows="2"
                        placeholder="Ingrese el valor correspondiente al atributo..."
                      ></textarea>
                      <small class="form-text text-muted">Ingrese el texto, URL, identificador o valor numérico según la especificación del atributo.</small>

                    <span class="text-danger d-block mt-2" v-if="editData.atributo=='billing_sequence_id' ||
                    editData.atributo=='sc_frequency' ||
                    editData.atributo=='sc_lifetime' ||
                    editData.atributo=='sc_payments' ||
                    editData.atributo=='sc_price' ||
                    editData.atributo=='restriction_bill' ||
                    editData.atributo=='sc_price_imp'
                    ">
                      <small><b>* Se recomienda no editar los atributos asociados a cobros desde este panel para evitar inconsistencias.</b></small>
                    </span>
                    </div>
                    <div v-if="errors" class="alert alert-danger" role="alert">
                      {{ errors }}
                    </div>
                  </form>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    @click="closeModal"
                  >
                    <span v-if="operation == 'jerarquia'">Cerrar</span>
                    <span v-else>Cancelar</span>
                  </button>
                  <button
                    type="button"
                    v-if="operation == 'delete'"
                    @click="deleteAtributo"
                    class="btn btn-primary"
                  >
                    Borrar
                  </button>
                  <button
                    type="button"
                    v-if="operation == 'edit'|| operation == 'create'"
                    @click="editAtributo"
                    class="btn btn-primary"
                  >
                    Guardar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>





<script>
import { mapGetters } from "vuex";
import axios from "axios";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { fetchCachedCatalog } from "../../utils/filterCache";

export default {
  name: "Atributos",
  props: {
    propProducto: {
      type: [Number, String],
      default: null,
    },
    propOperador: {
      type: [Number, String],
      default: null,
    },
    propServicio: {
      type: [Number, String],
      default: null,
    },
    propTipoSuscripcion: {
      type: [Number, String],
      default: null,
    },
    isModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      servicios: [],
      productos: [],
      operadores: [],
      tipoSuscripciones: [],
      success: null,
      integradorSel: localStorage.getItem("integrador"),
      error: null,
      atributos: null,
      jerarquia: null,
      atributosBusqueda: null,
      atributoSel: "",
      todos: 1,
      idKeywordSel: null, //119231,
      idProductoSel: null, //20842,
      idOperadorSel: null, //525,
      idTipoSuscripcionSel: null, //20,
      post: false,
      showModal: false,
      showModal2: false,
      editData: null,
      operation: null,
      page: 1,
      errors: [],
      borraNivel: null,
      valor: null,
      nivelpiso: "default",
      busquedaTimeout: null,
      filtroAtributoNombre: "",
      showExplicacionNiveles: false,
    };
  },
  created() {
    this.initParams();
    this.getAtributosBusqueda();
  },
  watch: {
    propProducto(val) {
      this.idProductoSel = val;
      this.debounceBusqueda();
    },
    propOperador(val) {
      this.idOperadorSel = val;
      this.debounceBusqueda();
    },
    propServicio(val) {
      this.idKeywordSel = val;
      this.debounceBusqueda();
    },
    propTipoSuscripcion(val) {
      this.idTipoSuscripcionSel = val;
      this.debounceBusqueda();
    },
    "$route.query": {
      handler() {
        if (!this.isModal) {
          this.initParams();
          this.debounceBusqueda();
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters("auth", ["user"]),
    atributosFiltrados() {
      if (!this.atributosBusqueda || !this.atributosBusqueda.data) return [];
      let list = this.atributosBusqueda.data;

      // Filtrar según el modelo / pantalla desde donde se llame
      if (this.idKeywordSel) {
        list = list.filter(
          (item) =>
            item.requerido_servicio === undefined ||
            item.requerido_servicio === null ||
            Number(item.requerido_servicio) === 1
        );
      } else if (this.idProductoSel) {
        list = list.filter(
          (item) =>
            item.requerido_producto === undefined ||
            item.requerido_producto === null ||
            Number(item.requerido_producto) === 1
        );
      } else if (this.idOperadorSel) {
        list = list.filter(
          (item) =>
            item.requerido_operador === undefined ||
            item.requerido_operador === null ||
            Number(item.requerido_operador) === 1
        );
      }

      if (!this.filtroAtributoNombre || !this.filtroAtributoNombre.trim()) {
        return list;
      }
      const term = this.filtroAtributoNombre.trim().toLowerCase();
      return list.filter((item) => {
        return item.atributo && item.atributo.toLowerCase().includes(term);
      });
    },
  },
  methods: {
    isValorVacio(val) {
      return val === null || val === undefined || String(val).trim() === "";
    },
    getExplicacionNivel(nivel) {
      switch (nivel) {
        case "servicio":
          return "Nivel Servicio: mayor prioridad, específico para este servicio.";
        case "producto":
          return "Nivel Producto: aplica al producto y sus servicios.";
        case "operador":
          return "Nivel Operador: configuración propia de la telco/operador.";
        case "tipo_suscripcion":
          return "Nivel Tipo de Suscripción: modalidad de la suscripción.";
        case "default":
          return "Nivel Default: valor base global del catálogo del sistema.";
        default:
          return nivel;
      }
    },
    initParams() {
      const q = (this.$route && this.$route.query) || {};
      if (this.propProducto !== null && this.propProducto !== undefined) {
        this.idProductoSel = this.propProducto;
      } else if (q.propProducto && q.propProducto > 0) {
        this.idProductoSel = q.propProducto;
      }

      if (this.propOperador !== null && this.propOperador !== undefined) {
        this.idOperadorSel = this.propOperador;
      } else if (q.propOperador && q.propOperador > 0) {
        this.idOperadorSel = q.propOperador;
      }

      if (this.propTipoSuscripcion !== null && this.propTipoSuscripcion !== undefined) {
        this.idTipoSuscripcionSel = this.propTipoSuscripcion;
      } else if (q.propTipoSuscripcion && q.propTipoSuscripcion > 0) {
        this.idTipoSuscripcionSel = q.propTipoSuscripcion;
      }

      if (this.propServicio !== null && this.propServicio !== undefined) {
        this.idKeywordSel = this.propServicio;
      } else if (q.propServicio && q.propServicio > 0) {
        this.idKeywordSel = q.propServicio;
      }
    },
    cargarFiltros: function () {
      return Promise.allSettled([
        this.getAtributos(),
        this.getServiciosBusqueda(),
        this.getTipodeSuscripcinesBusqueda(),
        this.getOperadoresBusqueda(),
        this.getProductosBusqueda()
      ]);
    },

    getNivelPiso(){


if (this.idKeywordSel != null) {
      this.nivelpiso = 'servicio';

}else if (this.idProductoSel != null) {
      this.nivelpiso = 'producto';

}else if (this.idOperadorSel != null) {
      this.nivelpiso = 'operador';

}else if (this.idTipoSuscripcionSel != null) {
      this.nivelpiso = 'tipo_suscripcion';

}

    },
    getServiciosBusqueda: function (hideResult = true) {
      if (hideResult) this.servicios = [];
      this.post = false;
      return fetchCachedCatalog(process.env.VUE_APP_API_URL + "servicio/busqueda", {
        id_integrador: this.integradorSel,
        get_all: true,
        order_by: { field: "keyword_desc", order: "ASC" },
      })
        .then((response) => {
          this.servicios = response;
        })
        .catch((e) => {
          this.errors.push(e);
           if (e.response && e.response.status==429) {
          Swal.fire({
            title: "Error!",
            text: "Espere un momento y vuelva a intentarlo.",
            icon: "error",
            confirmButtonText: "Aceptar",
          });
          }else{
          Swal.fire({
            title: "Error!",
            text: "Ha ocurrido un error al buscar las servicios",
            icon: "error",
            confirmButtonText: "Aceptar",
          });}
        })
        .finally(() => {
          this.post = true;
        });
    },
    getTipodeSuscripcinesBusqueda: function (hideResult = true) {
      if (hideResult) this.operadoresBusqueda = [];
      this.post = false;
      return fetchCachedCatalog(process.env.VUE_APP_API_URL + "tipoSuscripcion/busqueda", {
        get_all: true,
        order_by: { field: "id_tipo_suscripcion", order: "ASC" },
      })
        .then((response) => {
          this.tipoSuscripciones = response;
        })
        .catch((e) => {
          this.errors.push(e);
        })
        .finally(() => {
          this.post = true;
        });
    },
    getOperadoresBusqueda: function (hideResult = true) {
      if (hideResult) this.operadoresBusqueda = [];
      this.post = false;
      return fetchCachedCatalog(process.env.VUE_APP_API_URL + "operador/busqueda", {
        id_integrador: this.integradorSel,
        get_all: true,
        order_by: { field: "id_operador", order: "ASC" },
      })
        .then((response) => {
          this.operadores = response;
        })
        .catch((e) => {
          this.errors.push(e);
        })
        .finally(() => {
          this.post = true;
        });
    },
    vertodos(){
    this.todos=1;
    this.getAtributosBusqueda();
    },
     vermenos(){
    this.todos=0;
    this.getAtributosBusqueda();
    },
    getProductosBusqueda: function (hideResult = true) {
      if (hideResult) this.productosBusqueda = [];
      this.post = false;
      return fetchCachedCatalog(process.env.VUE_APP_API_URL + "producto/busqueda", {
        id_integrador: this.integradorSel,
        get_all: true,
        order_by: { field: "id_producto", order: "ASC" },
      })
        .then((response) => {
          this.productos = response;
        })
        .catch((e) => {
          this.errors.push(e);
           if (e.response && e.response.status==429) {
          Swal.fire({
            title: "Error!",
            text: "Espere un momento y vuelva a intentarlo.",
            icon: "error",
            confirmButtonText: "Aceptar",
          });
          }else{
          Swal.fire({
            title: "Error!",
            text: "Ha ocurrido un error al buscar las productos",
            icon: "error",
            confirmButtonText: "Aceptar",
          });}
        })
        .finally(() => {
          this.post = true;
        });
    },
    getAtributos: function () {
      this.atributos = null;
      return fetchCachedCatalog(process.env.VUE_APP_API_URL + "atributo/list")
        .then((response) => {
          this.atributos = response.data;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },




     getBillingSequencesBusqueda: function(id) {
      this.post = false;
      this.$store.commit("setLoading", true);
      return axios
        .post(process.env.VUE_APP_API_URL + "billingsequence/busqueda", {
          id_billing_sequence: id,
          id_integrador: this.integradorSel,
          
        })
        .then(response => {
          this.billingSequencesBusqueda = response.data;
        })
        .catch(e => {
         this.errors.push(e);
          if (e.response.status==429) {
          Swal.fire({
            title: "Error!",
            text: "Espere un momento y vuelva a intentarlo.",
            icon: "error",
            confirmButtonText: "Aceptar",
          });
          }else{
          Swal.fire({
            title: "Error!",
            text: "Ha ocurrido un error al buscar las servicios",
            icon: "error",
            confirmButtonText: "Aceptar"
          });}
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          this.post = true;
                    this.showsequence();

        });
    },











    getAtributosBusqueda: function () {
      this.atributosBusqueda = null;
      this.post = false;
      this.$store.commit("setLoading", true);
      const payload = {
        atributo: this.atributoSel,
        todos: this.todos,
        id_servicio: this.idKeywordSel,
        id_keyword: this.idKeywordSel,
        id_producto: this.idProductoSel,
        id_operador: this.idOperadorSel,
        id_tipo_suscripcion: this.idTipoSuscripcionSel,
      };
      if (this.idKeywordSel) {
        payload.requerido_servicio = 1;
        payload.modelo = "servicio";
      } else if (this.idProductoSel) {
        payload.requerido_producto = 1;
        payload.modelo = "producto";
      } else if (this.idOperadorSel) {
        payload.requerido_operador = 1;
        payload.modelo = "operador";
      }
      return axios
        .post(process.env.VUE_APP_API_URL + "atributo/busqueda", payload)
        .then((response) => {
          this.atributosBusqueda = response.data;
          this.getNivelPiso();
        })
        .catch((e) => {
          this.errors.push(e);
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          this.post = true;
        });
    },
    showDelete: function (atributo, nivel) {
      this.errors = null;
      this.editData = atributo;
      this.borranivel=nivel;
      this.showModal = true;
      this.operation = "delete";
    },
    deleteAtributo: function () {
      this.errors = null;
      this.$store.commit("setLoading", true);
      axios
        .post(process.env.VUE_APP_API_URL + "atributo/delete", {
          atributo: this.editData.atributo,
          id_servicio: this.editData.id_servicio || this.editData.id_keyword_has_producto || this.idKeywordSel,
          id_keyword: this.editData.id_servicio || this.editData.id_keyword_has_producto || this.idKeywordSel,
          id_producto: this.editData.id_producto,
          id_operador: this.editData.id_operador,
          id_tipo_suscripcion: this.editData.id_tipo_suscripcion,
        })
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data.error;
          } else {
            this.showModal = false;
            this.operation = null;
            this.editData = null;
          }
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.error) {
            this.errors = e.response.data.error;
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar eliminar",
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) this.getAtributosBusqueda();
        });
    },
    editAtributo: function () {
      this.errors = null;
      this.$store.commit("setLoading", true);
      axios
        .post(process.env.VUE_APP_API_URL + "atributo/update", {
          atributo: this.editData.atributo,
          id_servicio: this.idKeywordSel,
          id_keyword: this.idKeywordSel,
          id_producto: this.idProductoSel,
          id_operador: this.idOperadorSel,
          id_tipo_suscripcion: this.idTipoSuscripcionSel,
          valor: this.valor,
        })
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data.error;
          } else {
            Swal.fire({
              title: "Bien!",
              text: "Atributo actualizado correctamente",
              icon: "success",
              confirmButtonText: "Aceptar",
            });
            this.showModal = false;
            this.operation = null;
            this.editData = null;
          }
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.error) {
            this.errors = e.response.data.error;
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar guardar",
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) this.getAtributosBusqueda();
        });
    },
    showEdit: function (atributo) {
      this.errors = null;
      this.editData = atributo;
      this.valor = atributo.valor;
      this.showModal = true;
      this.operation = "edit";
    },
     showCreate: function (atributo) {
      this.errors = null;
      this.valor = atributo.valor;
      this.editData = atributo;
      this.showModal = true;
      this.operation = "create";
    },
    showJerarquia: function (atributo) {
      this.jerarquia = null;
      this.$store.commit("setLoading", true);
      this.editData = atributo;
      axios
        .post(process.env.VUE_APP_API_URL + "atributo/jerarquia", {
          atributo: atributo.atributo,
          id_servicio: this.idKeywordSel,
          id_keyword: this.idKeywordSel,
          id_producto: this.idProductoSel,
          id_operador: this.idOperadorSel,
          id_tipo_suscripcion: this.idTipoSuscripcionSel,
        })
        .then((response) => {
          this.jerarquia =
            response.data && response.data.data
              ? response.data.data
              : response.data;
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.error) {
            this.errors = e.response.data.error;
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al acceder a la jerarquía",
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          this.operation = "jerarquia";
          this.showModal = true;
        });
    },
    closeModal() {
      this.showModal = false;
      this.operation = null;
    },
    closeModal2() {
      this.showModal2 = false;
      this.operation = null;
    },
    showsequence: function () {
      this.showModal2 = true;
    },
    debounceBusqueda() {
      if (this.busquedaTimeout) {
        clearTimeout(this.busquedaTimeout);
      }
      this.busquedaTimeout = setTimeout(() => {
        this.getAtributosBusqueda();
      }, 50);
    },
  },
};
</script>

<style scoped>
.atributos-modal-view {
  width: 100%;
}

.fila-vacia,
.table-striped tbody tr.fila-vacia:nth-of-type(odd),
.table-striped tbody tr.fila-vacia:nth-of-type(even),
.fila-vacia > td,
.fila-vacia > th {
  background-color: #f8d7da !important;
  color: #721c24 !important;
}

.fila-vacia:hover,
.fila-vacia:hover > td,
.fila-vacia:hover > th {
  background-color: #f5c6cb !important;
}

.table-fixed {
  table-layout: fixed;
}

.table-fixed .break {
  word-wrap: break-word;
}

.table {
  table-layout: fixed;
}

.table td {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.modal-mask,
.nested-modal-mask {
  position: fixed !important;
  z-index: 9998;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  min-width: 100vw !important;
  min-height: 100vh !important;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  transition: opacity 0.3s ease;
}

.nested-modal-mask {
  z-index: 10050 !important;
  background-color: rgba(0, 0, 0, 0.65) !important;
}

.modal-wrapper {
  display: flex;
  justify-content: center;
  width: 100%;
}
</style>
